import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppPausePage } from './app-pause';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppPausePage,
  ],
  imports: [
    IonicPageModule.forChild(AppPausePage),
    PipesModule,
    DirectivesModule,
  ],
})
export class AppPausePageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-pause/app-pause.module.ts